const company = document.querySelector('.company');

let companyNavSwiper;
let companySecCurr;
let companySecTotal;
let companySecArr = [];
let companySecAccArr = [];
let companyNavlistArr = [];

if(company) {
  companyNavSwiper = new Swiper('.company__nav-wrapper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
  });

  company.querySelectorAll('.company__section').forEach(companySec => {
    companySecArr.push(companySec);
    companySecTotal = companySecArr.length;
  });
  company.querySelectorAll('.company__nav-item').forEach(companyNavEl => {
    companyNavlistArr.push(companyNavEl);
  });

  const companyNavEnabled = () => {
    company.querySelectorAll('.company__pagbtn').forEach(companyNavbtn => {
      companyNavbtn.disabled = false;
    });
  };
  const companySecChange = (target) => {
    companySecAccArr = [];
    companySecArr.forEach(companySecArrEl => {
      companySecArrEl.querySelectorAll('.accordion').forEach(accordionEl => {
        companySecAccArr.push(accordionEl);
      });

      if(companySecArrEl.getAttribute('id') == target) {
        companySecArrEl.classList.add('active');
      } else {
        companySecArrEl.classList.remove('active');
      }
    });

    companyNavlistArr.forEach(companyNavlistArrEl => {
      if(companyNavlistArrEl.getAttribute('data-target') == target) {
        companyNavlistArrEl.classList.add('active');
      } else {
        companyNavlistArrEl.classList.remove('active');
      }
    });

    companySecCurr = companySecArr.indexOf(company.querySelector(`#${target}`));
    companyNavSwiper.slideTo(companySecCurr, 3000);
    company.querySelector('.company__wrapper').style.transform = `translateX(-${100*companySecCurr}%)`;

    companySecAccArr.forEach(companySecAccArrEl => {
      let companySecAccArrElExp = companySecAccArrEl.querySelector('.accordion__expander');
      switch(companySecAccArrEl.classList.contains('active') && Boolean(companySecAccArrEl.closest(`#${target}`))) {
        case false:
          companySecAccArrElExp.style.height = null;
          break;

        case true:
          companySecAccArrElExp.style.height = `${companySecAccArrElExp.scrollHeight}px`;
          break;
      }
    });

    companyNavEnabled();
    switch(companySecArr.indexOf(company.querySelector('.company__section.active'))) {
      case 0:          
      company.querySelector('.company__pagbtn_prev').disabled = true;
      company.querySelector('.company__pagbtn_next').disabled = false;
      break;
  
      case companyNavlistArr.length - 1:
      company.querySelector('.company__pagbtn_prev').disabled = false;
      company.querySelector('.company__pagbtn_next').disabled = true;
      break;
    }

    if(companySecCurr > 9) {
      company.querySelector('.company__counter-current').textContent = companySecCurr + 1;
    } else {
      company.querySelector('.company__counter-current').textContent = `0${companySecCurr + 1}`;
    }
  };

  company.querySelectorAll('.company__nav-item').forEach(companyNavEl => {
    companyNavEl.addEventListener('click', e => {
      companySecChange(e.target.getAttribute('data-target'));
    });
  });

  company.querySelectorAll('.company__pagbtn').forEach(companyNavbtn => {
    companyNavbtn.addEventListener('click', e => {
      if(e.target.classList.contains('company__pagbtn_prev')) {
        companySecChange(companySecArr[companySecArr.indexOf(company.querySelector('.company__section.active')) - 1].getAttribute('id'));
        switch(companySecArr.indexOf(company.querySelector('.company__section.active'))) {
          case 0:          
            company.querySelector('.company__pagbtn_prev').disabled = true;
            break;
  
          case companyNavlistArr.length - 2:
            company.querySelector('.company__pagbtn_next').disabled = false;
            break;
        }
      }
      if(e.target.classList.contains('company__pagbtn_next')) {
        companySecChange(companySecArr[companySecArr.indexOf(company.querySelector('.company__section.active')) + 1].getAttribute('id'));
        switch(companySecArr.indexOf(company.querySelector('.company__section.active'))) {
          case 1:
            company.querySelector('.company__pagbtn_prev').disabled = false;
            break;
    
          case companyNavlistArr.length - 1:
            company.querySelector('.company__pagbtn_next').disabled = true;
            break;
        }
      }
    });
  });

  if(companySecTotal > 9) {
    company.querySelector('.company__counter-total').textContent = companySecTotal;
  } else {
    company.querySelector('.company__counter-total').textContent = `0${companySecTotal}`;
  }

  let companyNavLastItem = companyNavlistArr[companyNavlistArr.length - 1];
  let companyNavWidth = company.querySelector('.company__nav').getBoundingClientRect().width;
  let companyNavLeft = company.querySelector('.company__nav').getBoundingClientRect().left;
  let companyNavLastItemLeft = companyNavLastItem.getBoundingClientRect().left;
  let companyNavLastItemWidth = companyNavLastItem.getBoundingClientRect().width + Number(getComputedStyle(companyNavLastItem).marginRight.replace('px',''));
  if(companyNavLastItemLeft >= companyNavWidth) {
    document.documentElement.style.setProperty('--companyNavRight', 0);
  } else {
    document.documentElement.style.setProperty('--companyNavRight', `${companyNavWidth - companyNavLastItemLeft + companyNavLeft - companyNavLastItemWidth}px`);
  };
}